export default {
  add: 'Add client',
  countOfAnimals: 'Number of animals',
  degree: 'Degree',
  firstName: 'First name',
  fullName: 'Full name',
  lastName: 'Last name',
  createdAt: 'Date of creation',
  company: {
    address: 'Address company',
    hasCompany: 'Client has company',
    info: 'Info about company o',
    name: 'Name of company'
  },
  gender: {
    gender: 'Gender',
    male: 'Male',
    female: 'Female'
  },
  profile: {
    addAnimal: 'Add animal | Add animals',
    assignAnimal: 'Assign animal | Assign animals',
    notAssignedAnimals: 'Not assigned animals'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en/client.js